import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Typography, Card, CardContent } from '@mui/material';

export default function SolutionsSection() {
  const navigate = useNavigate();

  const solutions = [
    {
      title: "Lottery Theft Prevention",
      description: "Real-time monitoring and instant alerts to prevent lottery theft and fraud",
      url: "/lottery-theft-prevention",
      icon: "🛡️"
    },
    {
      title: "Automated Reconciliation",
      description: "Cut reconciliation time from 45 minutes to 5 minutes with AI-powered automation",
      url: "/lottery-reconciliation-software",
      icon: "⚡"
    },
    {
      title: "California Lottery Compliance",
      description: "Seamless SmartCount integration and automated compliance reporting",
      url: "/california-lottery-compliance",
      icon: "📋"
    },
    {
      title: "C-Store Management",
      description: "Complete multi-store lottery management with real-time performance tracking",
      url: "/convenience-store-lottery-management",
      icon: "🏪"
    },
    {
      title: "Inventory Tracking",
      description: "Real-time scratch-off inventory tracking with performance analytics",
      url: "/scratch-ticket-inventory-tracking",
      icon: "📊"
    }
  ];

  return (
    <section className="solutions-section" style={{ padding: '80px 0', backgroundColor: '#f8f9fa' }}>
      <div className="custom-container d-flex items-center width-100">
        <div style={{ maxWidth: '1200px', margin: '0 auto', width: '100%' }}>
          <div style={{ textAlign: 'center', marginBottom: '60px' }}>
            <Typography variant="h2" style={{ 
              fontSize: '2.5rem', 
              fontWeight: 'bold', 
              color: '#2c6ca0', 
              marginBottom: '16px' 
            }}>
              Complete Lottery Management Solutions
            </Typography>
            <Typography style={{ 
              fontSize: '1.2rem', 
              color: '#666', 
              maxWidth: '600px', 
              margin: '0 auto' 
            }}>
              Choose the specific solution that addresses your biggest lottery management challenges
            </Typography>
          </div>

          <div style={{ 
            display: 'grid', 
            gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', 
            gap: '24px' 
          }}>
            {solutions.map((solution, index) => (
              <Card 
                key={index}
                style={{ 
                  height: '100%', 
                  cursor: 'pointer',
                  transition: 'all 0.3s ease',
                  border: '1px solid #e0e0e0',
                  borderRadius: '12px'
                }}
                onClick={() => navigate(solution.url)}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-4px)';
                  e.currentTarget.style.boxShadow = '0 8px 25px rgba(0,0,0,0.15)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 2px 10px rgba(0,0,0,0.1)';
                }}
              >
                <CardContent style={{ padding: '30px', textAlign: 'center' }}>
                  <div style={{ 
                    fontSize: '3rem', 
                    marginBottom: '20px',
                    display: 'block'
                  }}>
                    {solution.icon}
                  </div>
                  <Typography variant="h5" style={{ 
                    fontWeight: 'bold', 
                    color: '#2c6ca0', 
                    marginBottom: '12px',
                    fontSize: '1.3rem'
                  }}>
                    {solution.title}
                  </Typography>
                  <Typography style={{ 
                    color: '#666', 
                    lineHeight: '1.6',
                    fontSize: '1rem'
                  }}>
                    {solution.description}
                  </Typography>
                  <div style={{ 
                    marginTop: '20px',
                    color: '#2c6ca0',
                    fontWeight: 'bold',
                    fontSize: '0.9rem'
                  }}>
                    Learn More →
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
